import {SET_USUARIO, UsuarioActionTypes} from "../types/usuarioActionTypes";
import {IUsuario} from "../../entities/catalogos/IUsuario";
import {Defaults} from "../../defaults/Defaults";

export const initialUsuario: IUsuario = {
    id: 0,
    usuario: "",
    nombre: "",
    apellido: "",
    password: "",
    telefono: "",
    email: "",
    rfcEmpresa: "",
    razonSocial: "",
    pais: Defaults.Mexico,
    codigoPostal: "",
    calle: "",
    numeroExterior: "",
    numeroInterior: "",
    tipoPersonaId: Defaults.tipoPersonaId,
};

export function usuarioReducer(state = initialUsuario, action: UsuarioActionTypes): IUsuario {
    switch (action.type) {
        case SET_USUARIO:
            return action.usuario;
        default:
            return state;
    }
}
